import apiGet, { apiPost, apiPut } from '../../Api';
import { mediaPath } from '../../media';

async function readJson(responsePromise) {
  const response = await responsePromise;
  if (!response.ok) throw new Error(await response.text());
  return response.json();
}

export function getAvatarConfig() {
  return readJson(apiGet('/avatar/config', true, { cache: 'no-store' }));
}

export function getPlayerAvatar() {
  return readJson(apiGet('/avatar/player'));
}

export function savePlayerAvatar(selection) {
  return readJson(apiPut('/avatar/player', JSON.stringify(selection), true));
}

export async function fetchAvatarImage(mediaId, variant) {
  if (!mediaId) return null;
  const response = await apiGet(mediaPath(mediaId, variant));
  if (!response.ok) return null;
  return URL.createObjectURL(await response.blob());
}

const renderBlobs = new Map();

export async function fetchAvatarRender(options) {
  const key = JSON.stringify(options);
  let pending = renderBlobs.get(key);
  if (!pending) {
    pending = apiPost(
      '/avatar/render',
      JSON.stringify(options),
      true,
      { cache: 'no-store' },
    ).then(async response => {
      if (!response.ok) throw new Error(await response.text());
      return response.blob();
    }).catch(error => {
      renderBlobs.delete(key);
      throw error;
    });
    renderBlobs.set(key, pending);
    if (renderBlobs.size > 100) renderBlobs.delete(renderBlobs.keys().next().value);
  }
  return URL.createObjectURL(await pending);
}
